import React from 'react';
import * as IdKey from 'short-uuid';
import { useForm, Controller } from "react-hook-form";
import { Button,
  Grid,
  Select,
  InputLabel,
  FormControl,
  CardContent,
  Card,
  MenuItem
} from '@material-ui/core';
import { useStateValue } from "../../context/store";
import { styles } from '../styles'



export default function PositionSearch({currentMaestras, currentCharges, currentLocation}) {
  const defaultValues = {
    regional: '',
    rolePosition: '',
    nameProfilePosition: '',
    immediateBoss: '',
  };

  const classes = styles();
  const [{}, dispatch] = useStateValue();


const { register, handleSubmit, control, setValue} = useForm({
  defaultValues
});

 const onSubmit = (data) => {
  if (
    data.nameProfilePosition !== null ||
    data.immediateBoss !== null ||
    data.location !== null ||
    data.rolePosition !== null ||
    data.status !== null
  ) {
    dispatch({
      type: "SET_FILTER",
      filter: {...data,  chargeMission: null},
      isFilter: true,
    });
  }
  }

   const clearForm = (e) => {
    setValue('location')
    setValue('rolePosition', null)
    setValue('immediateBoss', null)
    setValue('chargeMission', '')
    setValue('nameProfilePosition', null)
    setValue('status', "")
  };

  const clearBtn = () => {
    clearForm();
    dispatch({
      type: "SET_FILTER",
      filter: {
        rolePosition: null,
        nameProfilePosition: null,
        immediateBoss: null,
        location: null,
        chargeMission: null,
        status: null,
    },
    isFilter: true,
    });
  };


  return (
     <div >
        <Card elevation = {0} className={classes.card} style={{background: '#e0f2f7'}}>
        <CardContent>
        <form onSubmit={handleSubmit(onSubmit)} className={classes.form} >
            <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
               <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                >
                  <InputLabel htmlFor="outlined-select-rolePosition" shrink={true}> Rol del cargo </InputLabel>
                  <Controller
                  control={control}
                  name="rolePosition"
                  fullWidth
                  notched={true}
                  className = {classes.dropdownMultiple}
                  inputRef={register}
                  label="Rol del cargo"
                  size="small"
                  inputProps={{
                    name: "rolePosition",
                    id: "outlined-select-rolePosition",
                  }}
                  as = {
                    <Select
                  >
                     {currentMaestras?.rolDecargo.map((document) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={IdKey.generate()}
                        value={document}
                      >
                        {document}
                      </MenuItem>
                    ))}
                  </Select>
                  }/>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                 <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                >
                  <InputLabel htmlFor="outlined-select-immediateBoss" shrink={true}> Jefe inmediato </InputLabel>
                  <Controller
                  control={control}
                  name="immediateBoss"
                  fullWidth
                  notched={true}
                  className = {classes.dropdownMultiple}
                  inputRef={register}
                  label="Jefe inmediato"
                  size="small"
                  inputProps={{
                    name: "immediateBoss",
                    id: "outlined-select-immediateBoss",
                  }}
                  as = {
                    <Select
                  >
                     {currentCharges?.map((document) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={IdKey.generate()}
                        value={document?.id}
                      >
                        {document?.denomination}
                      </MenuItem>
                    ))}
                  </Select>
                  }/>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                 <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                >
                  <InputLabel htmlFor="outlined-select-location" shrink={true}> Regional </InputLabel>
                  <Controller
                  control={control}
                  name="location"
                  fullWidth
                  defaultValue=""
                  notched={true}
                  className = {classes.dropdownMultiple}
                  inputRef={register}
                  label="location"
                  size="small"
                  inputProps={{
                    name: "location",
                    id: "outlined-select-location",
                  }}
                  as = {
                    <Select
                  >
                     {currentLocation?.map((document) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={IdKey.generate()}
                        value={document}
                      >
                        {document}
                      </MenuItem>
                    ))}
                  </Select>
                  }/>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
                  <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                >
                  <InputLabel htmlFor="outlined-select-nameProfilePosition" shrink={true}> Perfil del cargo </InputLabel>
                  <Controller
                  control={control}
                  name="nameProfilePosition"
                  fullWidth
                  notched={true}
                  defaultValue=''
                  className = {classes.dropdownMultiple}
                  inputRef={register}
                  label="Perfil del cargo"
                  size="small"
                  inputProps={{
                    name: "nameProfilePosition",
                    id: "outlined-select-nameProfilePosition",
                  }}
                  as = {
                    <Select
                  >
                     {currentCharges?.map((x) => (
                      <MenuItem
                        className={classes.menuItem}
                        key={IdKey.generate()}
                        value={x.id}
                      >
                        {x.denomination}
                      </MenuItem>
                    ))}
                  </Select>
                  }/>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
            <FormControl  variant="outlined" fullWidth  size="small" >
              <InputLabel htmlFor="outlined-select-estado" shrink={true} size="small" >Estado</InputLabel>
              <Controller
              control={control}
              inputRef={register}
              fullWidth
              size="small"

              className = {classes.dropdown}
              label = "Estado"
              notched={true}
              name = "status"
              defaultValue=""
              // value = {formSearch.status}
              // onChange={handleOnchange}
              inputProps = {
                  {
                      name: 'status',
                      id: 'outlined-select-estado',
                  }
              }
              as={
              <Select >
                  <MenuItem
                      className={classes.menuItem}
                      key = {1}
                      value = "ACTIVO"
                  >
                    Activo
                  </MenuItem>
                  <MenuItem
                      className={classes.menuItem}
                      key = {2}
                      value = "INACTIVO"
                  >
                    Inactivo
                  </MenuItem>
              </Select>
              }
              />
            </FormControl>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Button
                variant="contained"
                className={classes.buttonSearch}
                type="submit"
              >
                Buscar
              </Button>
              &nbsp;&nbsp;
              <Button
                variant="contained"
                className={classes.buttonSearch}
                onClick={clearBtn}
              >
                Limpiar
              </Button>
        </Grid>
        </Grid>
        </form>
        </CardContent>

        </Card>
     </div>
  );

}
